module.exports = __webpack_public_path__ + "static/media/phone.52705c5f.svg";